// src/components/Login.tsx
import React from 'react';
import logo from '../assets/img/logo_fondotransparente_horizontal_Mesa de trabajo 1_Mesa de trabajo 1_Mesa de trabajo 1.png';
import login from '../styles/app.module.css';
import useLogin from '../hooks/useLogin';

const Login: React.FC = () => {
  const {
    email,
    setEmail,
    password,
    setPassword,
    error,
    isModalOpen,
    resetEmail,
    resetMessage,
    newPassword,
    setNewPassword,
    handleLogin,
    openModal,
    closeModal,
    handleResetChange,
    handlePasswordReset,
    handleConfirmNewPassword,
  } = useLogin();

  return (
    <div className={login.container}>
      <div className={login.logoContainer}>
        <img src={logo} alt="Aliadas" className={login.logo} />
      </div>
      <h1 className={login.welcome}>¡Bienvenida!</h1>
      {error && <p className={login.error}>{error}</p>}
      <form onSubmit={handleLogin} className={login.form}>
        <div className={login.inputt}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className={login.input}
          />
        </div>
        <div className={login.inputt}>
          <input
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className={login.input}
          />
        </div>
        <button type="submit" className={login.button}>Iniciar Sesión</button>
        <p className={login.forgot_password}>
          ¿Has olvidado la{' '}
          <a href="#" onClick={(e) => { e.preventDefault(); openModal(); }}>
            contraseña
          </a>?
        </p>
      </form>

      {isModalOpen && (
        <div className={login.modalOverlay} onClick={closeModal}>
          <div className={login.modalContent} onClick={(e) => e.stopPropagation()}>
            <button className={login.closeButton} onClick={closeModal}>&times;</button>
            <h3>Restablecer Contraseña</h3>
            {resetMessage ? (
              <>
                <p className={login.info}>{resetMessage}</p>
                <input
                  type="password"
                  placeholder="Nueva contraseña"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className={login.input}
                />
                <button
                  onClick={handleConfirmNewPassword}
                  className={login.button}
                  disabled={!newPassword}
                >
                  Confirmar Contraseña
                </button>
              </>
            ) : (
              <form onSubmit={handlePasswordReset} className={login.formReset}>
                <input
                  type="email"
                  placeholder="Tu correo"
                  value={resetEmail}
                  onChange={handleResetChange}
                  required
                  className={login.input}
                />
                <button type="submit" className={login.button}>Enviar enlace</button>
              </form>
            )}
          </div>
        </div>
        )}


    </div>
  );
};

export default Login;